import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFinder } from '../../DataStore/FinderContext';

const SearchBox = () => {
    const {setSearchText, searchText, searchActive, toggleSearch} = useFinder();
    const [query, setQuery] = useState(searchText);
    const navigate = useNavigate();

    const handleSearch = (e)=>{
        e.preventDefault();
        if(query.length > 0){
            setSearchText(query);
            navigate('/finder')
        }
    }

    const handleBtnClick = ()=>{
        navigate('/finder');
        toggleSearch(true);
    }

    return (
        <div className={`search-wrapper ${searchActive ? 'active' :''}`}>
        <div className="input-holder">
           <form method='post' onSubmit={handleSearch}>
            <input 
                type="text" 
                className="search-input" 
                placeholder="Type to search" 
                onChange={(e)=>setQuery(e.target.value)}
                value={query}
            />
            </form>
            <button className="search-icon" onClick={handleBtnClick}><span></span></button>
            
        </div>
        <button className="close" onClick={()=>toggleSearch(false)}></button>
    </div>
    );
};

export default SearchBox;